import { LogsInfo, LogsInfoStructured } from './models';
import { getCustomerForLogs, getOfferLogsInfo } from '@sunbit-dev/purchase-common/src/helpers/logs';
import { getPurchaseLogsInfo } from '~/helpers/logs';
import { loanApplicationNetworkService } from '../LoanApplicationNetworkService';
import { datadogRum } from '@sunbit-dev/common/services/datadog';
import { NetworkServiceError } from '@sunbit-dev/purchase-common/src/services/networkService/models';
import { generateString } from '@sunbit-dev/purchase-common/src/utilities/string';

export class LogsService {
  private infoData: Partial<LogsInfo>;

  setInfo(data: Partial<LogsInfo>) {
    this.infoData = { ...(this.infoData || {}), ...data };
  }

  addNetworkError({ error }: { error: NetworkServiceError }) {
    datadogRum.setGlobalContextProperty(`network-error-${generateString()}`, error);
  }

  get credentials() {
    const accessToken = loanApplicationNetworkService?.getToken();
    const shortToken = loanApplicationNetworkService?.getShortToken();
    const tokenExpiration = loanApplicationNetworkService?.getTokenExpiration();

    return {
      accessToken,
      shortToken,
      tokenExpiration,
    };
  }

  get info(): LogsInfoStructured {
    const { purchaseState, customerState, errorsState, experimentInfo, featureFlags } = this.infoData || {};

    const { purchaseInfo, offer } = purchaseState;
    const { customer, mlaStatus } = customerState;
    const { errorsInSession } = errorsState;

    return {
      purchaseInfo: getPurchaseLogsInfo(purchaseInfo),
      customer: getCustomerForLogs(customer),
      offer: getOfferLogsInfo(offer),
      credentials: this.credentials,
      mlaStatus,
      errorsInSession,
      url: window.location.href,
      experimentInfo,
      featureFlags,
    };
  }
}
